// Range input background update
function updateRangeBackground(range) {
    const value = ((range.value - range.min) / (range.max - range.min)) * 100;
    range.style.background = `linear-gradient(to right, #7DBCF9 ${value}%, #fff ${value}%)`;
}

document.querySelectorAll('.eco-inputs[type="range"]').forEach((range) => {
    range.addEventListener("input", function () {
        updateRangeBackground(this);
    });
    updateRangeBackground(range);
});

function updateRangeValue() {
    document.getElementById('rangeValue').textContent = document.getElementById('range').value;
}

const closeButton = document.querySelector('.calculate-close');

closeButton.addEventListener('click', function () {
    document.querySelector(".calculate-result-main").classList.remove('openCalculationModel');
    document.getElementsByTagName("body")[0].classList.remove('scroll-none')
});

function validateForm() {
    const form = document.getElementById('selectionForm');
    const inputs = form.querySelectorAll('input[required], select[required]');
    const submitButton = document.getElementById('submitButton');

    let allFilled = true;
    inputs.forEach(input => {
        if (!input.value) {
            allFilled = false;
        }
    });
  
    submitButton.disabled = !allFilled;
}

function revealAnswer() {

    document.getElementsByTagName("body")[0].classList.add('scroll-none')
    const revelElement = document.querySelector(".calculate-result-main");
    if (window.innerWidth < 991) {
        revelElement.classList.add("openCalculationModel")
    }

    const rangeValue = document.getElementById('range').value;
    const showtimeValue = document.getElementById('showtime').value;
    const waterUsageValue = document.getElementById('waterUsage').value;

    const answers = {
        '1': {
            '1': { '1': ['11.055', '49', '53.04'], '2': ['13.695', '61', '66.02'], '3': ['16.500', '73.5', '79'], '4': ['24.750', '110.25', '118.5'] },
            '2': { '1': ['16.583', '73.5', '79.56'], '2': ['20.543', '91.875', '99.14'], '3': ['24.750', '110.25', '118.5'], '4': ['37.125', '165.375', '177.75'] },
            '3': { '1': ['22.110', '98', '105.08'], '2': ['27.390', '121.77', '131.18'], '3': ['33.000', '147', '158'], '4': ['49.500', '220.5', '237'] },
            '4': { '1': ['27.638', '122.5', '131.6'], '2': ['34.238', '152.25', '163.22'], '3': ['41.250', '183.75', '197.5'], '4': ['61.875', '275.625', '296.25'] }
        },
        '2': {
            '1': { '1': ['22.110', '98', '105.08'], '2': ['27.390', '121.77', '131.18'], '3': ['33.000', '147', '158'], '4': ['49.500', '220.5', '237'] },
            '2': { '1': ['33.165', '147', '159.12'], '2': ['41.085', '183.75', '198.28'], '3': ['49.500', '220.5', '237'], '4': ['74.250', '330.75', '355.5'] },
            '3': { '1': ['44.220', '196', '210.16'], '2': ['54.780', '243.54', '262.36'], '3': ['66.000', '294', '316'], '4': ['99.000', '441', '474'] },
            '4': { '1': ['55.275', '245', '263.2'], '2': ['68.475', '304.5', '326.44'], '3': ['82.500', '367.5', '395'], '4': ['123.750', '551.25', '592.5'] }
        },
        '3': {
            '1': { '1': ['33.165', '147', '159.12'], '2': ['41.085', '183.75', '198.28'], '3': ['49.500', '220.5', '237'], '4': ['74.250', '330.75', '355.5'] },
            '2': { '1': ['49.748', '220.5', '238.68'], '2': ['61.628', '275.625', '297.42'], '3': ['74.250', '330.75', '355.5'], '4': ['111.375', '496.125', '533.25'] },
            '3': { '1': ['66.330', '294', '315.24'], '2': ['82.170', '365.31', '393.54'], '3': ['99.000', '441', '474'], '4': ['148.500', '661.5', '711'] },
            '4': { '1': ['82.913', '367.5', '394.8'], '2': ['102.713', '456.75', '489.66'], '3': ['123.750', '551.25', '592.5'], '4': ['185.625', '826.875', '888.75'] }
        },
        '4': {
            '1': { '1': ['44.220', '196', '210.16'], '2': ['54.780', '243.54', '262.36'], '3': ['66.000', '294', '316'], '4': ['99.000', '441', '474'] },
            '2': { '1': ['66.330', '294', '315.24'], '2': ['82.170', '365.31', '393.54'], '3': ['99.000', '441', '474'], '4': ['148.500', '661.5', '711'] },
            '3': { '1': ['88.440', '392', '420.32'], '2': ['109.560', '486.25', '525'], '3': ['132.000', '588', '632'], '4': ['198.000', '882', '948'] },
            '4': { '1': ['110.550', '490', '526.4'], '2': ['137.950', '609', '652.88'], '3': ['165.000', '735', '790'], '4': ['247.500', '1102.50', '1185.00'] }
        },
        '5': {
            '1': { '1': ['55.275', '245', '263.2'], '2': ['68.475', '304.5', '326.44'], '3': ['82.500', '367.5', '395'], '4': ['123.750', '551.25', '592.5'] },
            '2': { '1': ['82.913', '367.5', '394.8'], '2': ['102.713', '456.75', '489.66'], '3': ['123.750', '551.25', '592.5'], '4': ['185.625', '826.875', '888.75'] },
            '3': { '1': ['110.550', '490', '526.4'], '2': ['137.950', '609', '652.88'], '3': ['165.000', '735', '790'], '4': ['247.500', '1102.50', '1185.00'] },
            '4': { '1': ['137.888', '612.5', '657'], '2': ['171.188', '761.25', '815.1'], '3': ['206.250', '917.5', '987.5'], '4': ['309.375', '1,377.75', '1481.25'] }
        },
        '6': {
            '1': { '1': ['66.330', '294', '315.24'], '2': ['82.170', '365.31', '393.54'], '3': ['99.000', '441', '474'], '4': ['148.500', '661.5', '711'] },
            '2': { '1': ['99.165', '441', '474.36'], '2': ['123.255', '548.75', '594.84'], '3': ['148.500', '661.5', '711'], '4': ['222.750', '992.25', '1066.50'] },
            '3': { '1': ['132.660', '588', '630.48'], '2': ['164.340', '730.63', '787.08'], '3': ['198.000', '882', '948'], '4': ['297.000', '1323.00', '1422.00'] },
            '4': { '1': ['166.050', '735', '789.6'], '2': ['205.950', '913.5', '1044.10'], '3': ['247.500', '1102.50', '1185.00'], '4': ['371.250', '1653.75', '1777.50'] }
        }
    };

    const answersData = answers[rangeValue]?.[showtimeValue]?.[waterUsageValue];
    if (answersData) {
        // Display different icons above the numbers for each result
        document.getElementById('answer1').innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0624/6514/7212/files/Group_26.svg?v=1725343945" />
          <span>${answersData[0]}</span> Liter water`;

        document.getElementById('answer2').innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0624/6514/7212/files/Group_27.svg?v=1725343945" />
          <span>${answersData[1]}</span> kWh energie`;

        document.getElementById('answer3').innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0624/6514/7212/files/Group_28.svg?v=1725343946" />
          <span>€${answersData[2]}</span> Per jaar`;

        // Logic for displaying specific text based on "Per jaar"
        const savingsPerYear = parseFloat(answersData[2].replace(',', '.'));
        let displayText = '';
        if (savingsPerYear < 200) {
            displayText = 'Met deze besparing kan jij een gratis dagje weg op jaar basis!';
        } else if (savingsPerYear >= 200 && savingsPerYear <= 500) {
            displayText = 'Met deze besparing kan jij een maand gratis boodschappen halen op jaar basis!';
        } else {
            displayText = 'Met deze besparing kan je genieten van een gratis vakantie op jaar basis!';
        }
        document.getElementById('perJaarText').textContent = displayText;

        document.getElementById('answer').style.display = 'block';
    } else {
        document.getElementById('answer').style.display = 'none';
    }
}
